import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'btn1Hover',
  $names: {
    target: '[data-js-hover=btn3]',
    inner: '.mask_in',
  },
  styleInfo: {
    colorHovered: '#f1f1f1',
    colorDefault: '#0d0d0d',
    bgColorHovered: '#0d0d0d',
    bgColorDefault: '#ceff00',
  },
}

export default class Btn3Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($inner) {
        gsap.killTweensOf($inner, 'backgroundColor')
        gsap.to($inner, {
          color: this.styleInfo.colorHovered,
          backgroundColor: this.styleInfo.bgColorHovered,
          duration: 0.5,
          ease: 'quart.out',
        })
      }

      gsap.delayedCall(0.4, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $inner = $target.querySelector(this.$names.inner)
      if ($inner) {
        gsap.killTweensOf($inner, 'backgroundColor')
        gsap.to($inner, {
          color: this.styleInfo.colorDefault,
          backgroundColor: this.styleInfo.bgColorDefault,
          duration: 0.5,
          delay: 0.05,
        })
      }

      resolve()
    })
  }
}